/**
 * hold-repeat.ts — авто-повтор при зажатии кнопок +/- количества
 * Проект: TorgiRT (shared — все витрины)
 *
 * Делегирование на document: при зажатии кнопки change-qty > 400мс
 * начинается авто-повтор (200мс → 80мс после 5 тиков).
 * Клик остаётся как есть (±1). Листовой модуль без импортов.
 */

const INITIAL_DELAY = 400;
const SLOW_INTERVAL = 200;
const FAST_INTERVAL = 80;
const ACCEL_AFTER = 5;

let timer: ReturnType<typeof setTimeout> | null = null;
let ticks = 0;

function stop(): void {
  if (timer !== null) clearTimeout(timer);
  timer = null;
  ticks = 0;
}

function tick(btn: HTMLElement): void {
  if ((btn as HTMLButtonElement).disabled) { stop(); return; }
  const article = (btn).dataset.article;
  const delta = (btn).dataset.delta;
  btn.click();
  ticks++;

  const freshBtn = document.querySelector(
    '[data-action="change-qty"][data-article="' + article + '"][data-delta="' + delta + '"]'
  );
  if (!freshBtn || (freshBtn as HTMLButtonElement).disabled) { stop(); return; }

  const delay = ticks >= ACCEL_AFTER ? FAST_INTERVAL : SLOW_INTERVAL;
  timer = setTimeout(function () { tick(freshBtn as HTMLElement); }, delay);
}

function start(e: MouseEvent | TouchEvent): void {
  const target = ('touches' in e) ? (e.touches[0]?.target as Element | null) : (e.target as Element | null);
  if (!target) return;
  const btn = (target).closest('[data-action="change-qty"]');
  if (!btn || (btn as HTMLButtonElement).disabled) return;
  stop();
  timer = setTimeout(function () { tick(btn as HTMLElement); }, INITIAL_DELAY);
}

/**
 * Инициализация hold-to-repeat.
 * Вызывается один раз при старте приложения.
 */
export function initHoldRepeat(): void {
  document.addEventListener("mousedown", start);
  document.addEventListener("touchstart", start as EventListener, { passive: true });
  document.addEventListener("mouseup", stop);
  document.addEventListener("mouseleave", stop);
  document.addEventListener("touchend", stop);
  document.addEventListener("touchcancel", stop);
}
